import { http } from "@/http";
import stationsData from "@/assets/jsons/stations_filtered.json";
import mockMapData from '@/modules/map/__mocks__/monitoring-map-mock.json';
//import stationsCached from "@/assets/jsons/stations_cached.json";

const isLocal = () => window.__env?.back_end?.enviroment === 'local';

class MonitoringService {

  async getMapMountpoints(body) {
    console.log(body)
    if (isLocal()) {
      return { data: mockMapData.data };
    }
    let params = {};
    params["topleft"] = body["topLeft"]
      ? body["topLeft"][0] + "," + body["topLeft"][1]
      : null;
    params["bottomright"] = body["bottomRight"]
      ? body["bottomRight"][0] + "," + body["bottomRight"][1]
      : null;
    return await http.get(`/cached-map-monitoring/mountpoint-monitoring-pagination`, {
      params,
    });
  }
  async getMonitoringListPaginatedFiltered(params) {
    // return await http.get(`/monitoring/mountpoint-monitoring-pagination`, {
    //   params,
    // });
    return await new Promise(() => {
      let response = { data: stationsData[params["page"]] };
      return response;
    });
  }
  async getMonitoringMapPaginated(body,signal) {
    if (isLocal()) {
      return { data: mockMapData };
    }
    let params = {};
    params["size"] = body["size"];
    params["page"] = body["page"];
    params["topleft"] = body["topLeft"]
      ? body["topLeft"][0] + "," + body["topLeft"][1]
      : null;
    params["bottomright"] = body["bottomRight"]
      ? body["bottomRight"][0] + "," + body["bottomRight"][1]
      : null;
    return await http.get(`/monitoring/mountpoint-monitoring-pagination`, {
      params,
      signal
    });
  }
}
export default new MonitoringService();
